import { WSList, WSText } from "@wingspanhq/fe-component-library";
import { useMemo } from "react";
import { FlowMEChangeContext } from "..";
import { useUserId } from "../../../../../query/hooks/helpers";
import {
  useQueryMemberProfile,
  useQueryUserProfile
} from "../../../../../query/users/queries";
import { useQueryUserProfileV2 } from "../../../../../query/user/queries/useQueryUserProfile";
import { useFlowContext } from "../../../../../shared/components/Flow";
import { getProfileDataPerson } from "../../../components/FormPartialPerson/getProfileDataPerson";
import { FormRepresentative } from "../../../components/FormRepresentative";
import { useRequiresBankingVerification } from "../../../hooks/useRequiresBankingVerification";
import { OnboardingStep } from "../../../types";

export const StepMaterialUpdateRepresentative: React.FC<
  OnboardingStep
> = props => {
  const [context, setContext] = useFlowContext<FlowMEChangeContext>();
  const requiresBanking = useRequiresBankingVerification();

  const userId = useUserId();
  const queryUser = useQueryUserProfile(userId);
  const queryMember = useQueryMemberProfile(userId);
  const queryUserV2 = useQueryUserProfileV2();
  const profileData = useMemo(
    () => ({
      representative: getProfileDataPerson({
        type: "Representative",
        user: queryUser.data,
        member: queryMember.data,
        userV2: queryUserV2.data
      })
    }),
    [queryMember.data, queryUser.data, queryUserV2.data]
  );

  const country = context.accountType?.country || "US";
  const singleOwnershipStake =
    country === "US" &&
    context.accountType?.type === "Business" &&
    context.businessInformation?.taxClassification === "LlcSingleMember";

  return (
    <WSList gap="2XL">
      <FormRepresentative
        singleOwnershipStake={singleOwnershipStake}
        defaultValues={context.representative || profileData}
        country={country}
        onBack={props.onBack}
        onSubmit={data => {
          setContext(prev => ({
            ...prev,
            representative: data
          }));
          props.onNext?.();
        }}
        includeBeneficialOwners={requiresBanking}
        requireTaxId={requiresBanking}
      />

      <WSText.ParagraphXs color="gray400">
        The information on this page is required to setup your Wingspan account,
        if you exit or leave without completing this step, you will return to
        this page the next time you sign-in
      </WSText.ParagraphXs>
    </WSList>
  );
};
